import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderDropdownComponent } from '../../../header/header-dropdown/header-dropdown.component';
import { ApplicationHeaderInfoComponent } from '../../../header/application-header-info/application-header-info.component';

@Component({
    selector: 'app-application-header',
    templateUrl: './application-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        HeaderDropdownComponent,
        ApplicationHeaderInfoComponent,
    ],
})
export class ApplicationHeaderComponent {}
